@if (mainConfig && innerConfig && innerConfigDataMethod) {
    <expandable-list
        [config]="mainConfig"
        [innerConfig]="innerConfig"
        [innerConfigDataMethod]="innerConfigDataMethod"
        [colSpan]="6"
    ></expandable-list>
}
